import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert, FormGroup } from "reactstrap";
import { put, get, post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import Loader from "common/loader";
import { SHOW_PARTNER, UPDATE_PARTNER, UPLOAD_FILE, COUNTRIES_SEARCH, LANGUAGES_SEARCH, UPDATE_USER } from "helpers/api_endpoints";
import moment from "moment";
import Select from "react-select";


//meta title
document.title = "Edit Partner";

const EditPartner = () => {
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [id, setId] = useState('');
    const [status, setStatus] = useState(1);
    const [name, setName] = useState('{"title":[{"1":""}]}');
    const [named, setNamed] = useState('');
    const [email, setEmail] = useState(null);
    const [password, setPassword] = useState(null);
    const [oldPassword, setOldPassword] = useState(null);
    const [languages, setLanguages] = useState([]);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [deliveryConfirmationMethods, setDeliveryConfirmationMethods] = useState([]);
    const [pickupConfirmationMethods, setPickupConfirmationMethods] = useState([]);
    const [countryCode, setCountryCode] = useState('');
    const [userId, setUserId] = useState('');
    const [verifyType, setVerifyType] = useState(2);
    const [licenseFilePath, setLicenseFilePath] = useState('');
    const [countries, setCountries] = useState([]);
    const [contractStartDate, setContractStartDate] = useState(moment().format("YYYY-MM-DD"));
    const [contractEndDate, setContractEndDate] = useState(moment().add(1, 'y').format("YYYY-MM-DD"));
    const [errorMsg, seterrorMsg] = useState('');
    const [emergencyNotification, setEmergencyNotification] = useState(1)
    const [emergencyNotificationNumbers, setEmergencyNotificationNumbers] = useState([])
    const [chooseModal, setChooseModal] = useState(false);
    const navigate = useNavigate();

    const itemConfirmationList = [{label: 'Scan QR Code', value: 'Scan QR Code'},{label: 'Take a photo of the package', value: 'Take a photo of the package'}];
    const deliveryConfirmationList = [{value:'Passport', label:'Passport'}, {value: 'Emirates ID', label:'Emirates ID'}, {value: 'Door image', label:'Door image'}, {value: 'User OTP', label:'User OTP'}];

    useEffect(() => {
        setPartnerData();
    }, []);

    useEffect(() => {
        post(`${LANGUAGES_SEARCH}`,{status:1})
            .then(response => {
                setLanguages(response.data);
                // console.log(languages);
                setLoading(false);
            })
            .catch(error => {
                console.log(error)
                // navigate('/collhub');
            })
    }, []);

    useEffect(() => {
        const start = moment(contractStartDate, 'YYYY-MM-DD');
        const end = moment(contractEndDate, 'YYYY-MM-DD');
        if(start.diff(end)>=0)
        {
            setContractEndDate(start.add(1, 'y').format("YYYY-MM-DD"))
        }
     }, [contractEndDate, contractStartDate]);

     const checkPhoneNumber = (type, value) => {
        const regx1 = /^(50|52|54|55|56|58)\d{7}$/
        const regx2 = /^(02|03|04|05|06|07|08)\d{7}$/
        
        if (type === 1 && value.length < 9) {  // onBlur
            if (!regx1.test(value) && !regx2.test(value)) {
                setPhoneNumber('');
                return;
            }
        }
        
        // Only update if the value actually changed
        if (phoneNumber !== value) {
            setPhoneNumber(value);
        }
    }

    const handleCountryCode = (countryCode) => {
        // Remove first two digits from phone number if country code is changing
        if (phoneNumber && phoneNumber.length >= 2) {
            setPhoneNumber(phoneNumber.substring(2));
        }
        setCountryCode(countryCode)
    }
    

    const setPartnerData = () => {
        get(`${SHOW_PARTNER}/${params.id}`)
            .then(response => {
                const partner = response.data;
                setName(JSON.stringify(partner.named));
                setNamed(partner.named);
                let phoneWithoutCountryCode = partner.phoneNumber;
                if (partner.countryCode) {
                    const countryCodeLength = partner.countryCode.replace('+', '').length;
                    phoneWithoutCountryCode = partner.phoneNumber.substring(countryCodeLength);
                }
                setPhoneNumber(phoneWithoutCountryCode);
                setContractStartDate(partner.contractStartDate.split('T')[0]);
                setContractEndDate(partner.contractEndDate.split('T')[0]);
                setDeliveryConfirmationMethods(partner.deliveryConfirmationMethods || [])
                setPickupConfirmationMethods(partner.pickupConfirmationMethods || [])
                setId(partner.id);
                setUserId(partner.userId);
                setVerifyType(partner.verifyType);
                setEmergencyNotification(partner.emergencyNotification);
                setEmergencyNotificationNumbers(partner.emergencyNotificationNumbers);
                setStatus(partner.status);
                setCountryCode(partner.countryCode);
                setLicenseFilePath(partner.licenseFilePath);
                setEmail(partner.user?.email || '');
                setPassword('');
                setLoading(false);
            })
            .catch(error => {
                console.log(error)
                // navigate('/Partners');
            })
    }

    const handleSubmit = () => {
        updatePartnerData();
    }

    useEffect(() => {
        getCountries();
    }, []);

    const getCountries = () => {
        post(`${COUNTRIES_SEARCH}`)
            .then(response =>{
                setCountries([{value:'0',label:'None'}].concat(response.data.map(el=>{
                    return {value:el.countryCode,label:el.countryCode, flagUrl: el.countryCode}
                })));
            })
    };



    const updatePartnerData = () => {
        // Remove + from country code if present
        const cleanedCountryCode = countryCode ? countryCode.replace('+', '') : '';
        
        // Combine country code with phone number (phone number already has first two digits removed)
        const fullPhoneNumber = cleanedCountryCode && phoneNumber ? `${cleanedCountryCode}${phoneNumber}` : phoneNumber;
        const data = {id, name, licenseFilePath, phoneNumber: fullPhoneNumber, contractStartDate, contractEndDate, status, verifyType, countryCode, pickupConfirmationMethods
            , deliveryConfirmationMethods, email, emergencyNotification, emergencyNotificationNumbers};
        put(UPDATE_PARTNER, data)
            .then(response => {
                if (response.code == 200) {
                    updateUserData().then(resp => {

                        navigate('/Partners', { state: { successMsg: 'Partner Updated SuccessFully' } });
                    })
                }
            })
            .catch(error => {
                seterrorMsg(error?.response?.data?.message || 'Partner Updation Failed');
            })
    }

    const updateUserData = async () => {
        const cleanedCountryCode = countryCode ? countryCode.replace('+', '') : '';
        const fullPhoneNumber = cleanedCountryCode && phoneNumber ? `${cleanedCountryCode}${phoneNumber}` : phoneNumber;
        const ob = { id: userId, name: name, email, password, status, mobile: fullPhoneNumber, emergencyNotificationNumbers, emergencyNotification };
        if(password && password!='')
            ob.password = password;
        return put(UPDATE_USER, ob)
            .then(response => {
                if (response.code == 200) {
                    // navigate('/drivers', { state: { successMsg: 'Driver Updated SuccessFully' } });
                    return 'ok';
                }
                else {
                    return response.message;
                }
            })
            .catch(error => {
                console.log(error)
                return error.response.data.message;
            })
    }

    const handleToggleCheckBox = (inputFunction) => {
        switch (inputFunction) {
            case 'setStatus':
                if (status == 1) {
                    setStatus(2);
                }
                else {
                    setStatus(1);
                }
                break;
            case 'setVerifyType':
                if (verifyType == 1) {
                    setVerifyType(2);
                }
                else {
                    setVerifyType(1);
                }
                break;
            case "setEmergencyNotification":
                if (emergencyNotification == 1) {
                setEmergencyNotification(0)
                } else {
                setEmergencyNotification(1)
                }
            default:
                break;
        }
    }

    const clearPhoto = () => {
        if(licenseFilePath != '')
        setLicenseFilePath('');
    }

    const handleFileUpload = (event) => {
        // setLoading(true);
        const file = event.target.files[0];
        console.log(file.type);
        if(file.size > 1*1024*1024)
        {
            seterrorMsg('File size is larger than 1MB');
            setTimeout(()=>{
                seterrorMsg('');
            },1700)
        }
        if(file.type != 'image/jpeg' && file.type != 'image/png')
        {
            seterrorMsg('File type is incorrect');
            setTimeout(()=>{
                seterrorMsg('');
            },1700)
        }
        post(`${UPLOAD_FILE}`, { file, type:"partners", fullPath:"true" }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                const data = response.data;
                setLicenseFilePath(data.path);
                // setLoading(false);
            })
            .catch((error) => {
            });
    }

    const handleName = (languageId,value) => {
        if(!named.title){
            setNamed({"title":[{"1":value}]});
            return;  
        } 
        const ln = named.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            named.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setName(JSON.stringify(named));             
    }

    const setNNumber = (i, val) => {

        const tmp = [...emergencyNotificationNumbers];
        tmp[i] = val;
        setEmergencyNotificationNumbers(tmp);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Partners" breadcrumbItem="Edit Partner" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={8}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                        <Row>
                                        {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}

                                            {languages.map((language, index) => (
                                                <div className="form-group col-md-3 mt-2" key={index}>
                                                    <Label className="form-label"><Trans>Name ({language.name})</Trans></Label>
                                                    <Input
                                                        name="name"
                                                        value={named.title?named.title.find(el => {return el[language.id]})?named.title.find(el => {return el[language.id]})[language.id]:'':''}
                                                        className="form-control"
                                                        placeholder="Enter Name"
                                                        type="text"
                                                        onChange={(e) => handleName(language.id,e.target.value)}
                                                        required={language.id==1||language.id==2?true:false} ></Input>
                                                    <Input type="hidden" name="id"></Input>
                                                </div>
                                                ))
                                            }
                                        
                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Email</Trans></Label>
                                                    <Input
                                                        name="email"
                                                        value={email}
                                                        className="form-control"
                                                        placeholder="Enter Email"
                                                        type="email"
                                                        autoComplete="off"
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Password</Trans></Label>
                                                    <Input
                                                        name="password"
                                                        className="form-control"
                                                        placeholder="Enter Password"
                                                        type="password"
                                                        autoComplete="false"
                                                        onChange={(e) => setPassword(e.target.value)} 
                                                        required
                                                    ></Input>
                                                </div>

                                        <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label"><Trans>Country Code</Trans></Label>
                                                <Select
                                                        name="countryCode"
                                                        value={countries.find(el => el.value==countryCode)}
                                                        options={countries} 
                                                        className="form-control select2"
                                                        onChange={(e) => handleCountryCode(e.value)}
                                                    />
                                        </div>

                                        <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label"><Trans>Phone Number</Trans></Label>
                                            <Input
                                                name="phoneNumber"
                                                value={phoneNumber}
                                                className="form-control"
                                                placeholder="Enter Number"
                                                type="text"
                                                onBlur={(e) => checkPhoneNumber(1,e.target.value)}
                                                onChange={(e) => checkPhoneNumber(2,e.target.value)}
                                            required ></Input>
                                        </div>

                                        <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label"><Trans>Contract Start Date</Trans></Label>
                                            <Input
                                                name="contractStartDate"
                                                value={contractStartDate}
                                                className="form-control"
                                                placeholder="Enter "
                                                type="date"
                                                onChange={(e) => setContractStartDate(e.target.value)} required
                                            ></Input>
                                        </div>

                                        <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label"><Trans>Contract End Date</Trans></Label>
                                            <Input
                                                name="contractEndDate"
                                                value={contractEndDate}
                                                className="form-control"
                                                placeholder="Enter "
                                                type="date"
                                                onChange={(e) => setContractEndDate(e.target.value)} required
                                            ></Input>
                                        </div>

                                        <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label"><Trans>Status</Trans></Label>
                                            <div className="form-check form-check-end">
                                                    <FormGroup switch>
                                                    <Input
                                                        type="switch"
                                                        size="md"
                                                        checked={status==2}
                                                        onClick={() => {
                                                            handleToggleCheckBox('setStatus');
                                                        }}
                                                        />
                                                    </FormGroup>
                                            </div>
                                        </div>
                                        <div className="form-group col-md-2 mt-2">
                                            <Label className="form-label">
                                            <Trans>Emergency notification</Trans>
                                            </Label>
                                            <div className="form-check form-check-end">
                                            <FormGroup switch>
                                                <Input
                                                type="switch"
                                                size="md"
                                                checked={emergencyNotification == 1}
                                                onClick={() => {
                                                    handleToggleCheckBox("setEmergencyNotification")
                                                }}
                                                />
                                            </FormGroup>
                                            </div>
                                        </div>
                                        <div className="form-group col-md-12 mt-2 justify-content-center my-auto">
                                            <Label className="form-label">
                                            <Trans>Emergency Notification Numbers</Trans>
                                            </Label>
                                            <Row>
                                            {emergencyNotificationNumbers? emergencyNotificationNumbers.map((num, i) =>(
                                                <div key={i} className="form-group col-md-3 mt-2">
                                                    <Input
                                                        name="emergencyNumber"
                                                        value={emergencyNotificationNumbers[i]}
                                                        className="form-control"
                                                        placeholder={`Enter 971XXXXXXXXX `}
                                                        type="number"
                                                        onChange={(e) => setNNumber(i, e.target.value)} 
                                                    ></Input>
                                                </div>

                                            )):<></>}
                                                <Row className="justify-content-center">
                                                <div className="form-group col-md-6 mt-2 my-auto">
                                                <Input
                                                    name="emergencyNumberAdd"
                                                    value="Add Notify Mobile"
                                                    className="form-control bg-primary "
                                                    type="button"
                                                    onClick={(e) => {setEmergencyNotificationNumbers([...emergencyNotificationNumbers, '']);}} 
                                                ></Input>
                                                </div>
                                                </Row>
                                            </Row>
                                        </div>
                                            {/* <div className="form-group col-md-2 mt-2">
                                                <Label className="form-label"><Trans>Verify scan</Trans></Label>
                                                <div className="form-check form-check-end">
                                                    <FormGroup switch>
                                                    <Input
                                                        type="switch"
                                                        size="md"
                                                        checked={verifyType==2}
                                                        onClick={() => {
                                                            handleToggleCheckBox('setVerifyType');
                                                        }}
                                                        />
                                                    </FormGroup>
                                                </div>
                                            </div> */}
                                            <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Pickup item confirmation</Trans></Label>
                                                    <Select
                                                        isMulti="true"
                                                        name="deliveryConfirmationMethods"
                                                        value={itemConfirmationList.filter(el => {
                                                            return pickupConfirmationMethods.includes(el.value);
                                                        })}
                                                        options={itemConfirmationList} 
                                                        className="form-control select2"
                                                        onChange={(e) => {setPickupConfirmationMethods(e.map(m => m.value));}}
                                                        required
                                                    />
                                            </div>
                                            <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Delivery Confirmation Methods</Trans></Label>
                                                    <Select
                                                        isMulti="true"
                                                        name="deliveryConfirmationMethods"
                                                        value={deliveryConfirmationList.filter(el => {
                                                            return deliveryConfirmationMethods.includes(el.value);
                                                        })}
                                                        options={deliveryConfirmationList} 
                                                        className="form-control select2"
                                                        onChange={(e) => {setDeliveryConfirmationMethods(e.map(m => m.value));}}
                                                        required
                                                    />
                                            </div>
                                        
                                    </Row>
                                    }
                                        <div className="mt-4">
                                            <Button type="submit" color="danger">
                                                <Trans>Submit</Trans>
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xl={4}>
                                        <div className="form-group col-md-12 mt-2">
                                            <Label className="form-label"><Trans>Commercial License</Trans></Label>
                                            <input className="form-control" type="file" onChange={handleFileUpload} />
                                        </div>
                                        <div>
                                            <input className="form-control" type="button" value="X" onClick={clearPhoto} />
                                            <img src={licenseFilePath} width="170" height="270" />
                                        </div>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditPartner
